import { render, staticRenderFns } from "./HelpBlock.vue?vue&type=template&id=3ad0a0e0&scoped=true&"
import script from "./HelpBlock.vue?vue&type=script&lang=js&"
export * from "./HelpBlock.vue?vue&type=script&lang=js&"
import style0 from "./HelpBlock.vue?vue&type=style&index=0&id=3ad0a0e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad0a0e0",
  null
  
)

export default component.exports